<template>
  <v-col class="register default-slot" md="7" sm="12">
    <v-dialog v-model="dialog" width="500px">
      <v-card class="confirmation-modal">
        <v-img
          class="modal-icon"
          width="84"
          :src="thumbsUpImage"
        />
        <h2 class="mt-8 mb-8">
          Thank you, your kennel has been submitted. You will be notified of
          approval.
        </h2>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" width="500px">
      <v-card class="confirmation-modal">
        <h2 class="mt-8 mb-8">
          {{ errorMessage }}
        </h2>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <a
        class="back-icon"
        v-on:click="changePage(1);"
      >
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title">Kennel Name Registration Application</h1>
    <v-form class="register-form" v-model="isValid">
      <div class="table-gray-box">
        <table>
          <tr>
            <td>Kennel Registration</td>
            <td>${{ price }}</td>
                        <v-tooltip bottom content-class="fee-table-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"
                  ><font-awesome-icon icon="info-circle"
                /></span>
              </template>
              <simple-fee-table :priceInfo="priceInfo" excludeService />
            </v-tooltip>
          </tr>
          <tr>
            <td>Total</td>
            <td>${{ price }}</td>
          </tr>
        </table>
      </div>
      <div class="table-gray-box">
        <h4>Owners</h4>
        <p v-if="!!userInfo">
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
              <font-awesome-icon
                icon="paw"
                :color="'blue'"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <span>
              {{
                "The primary kennel owner is the main contact person for the ASCA office."
              }}<br />
              {{
                "Only they can initiate kennel ownership transfer in the future."
              }}
            </span>
          </v-tooltip>
          <span>
            {{ userInfo.firstName }} {{ userInfo.lastName }}
            <span v-if="!!userInfo.memberId">
              (Member: {{ userInfo.memberId }})
            </span> </span
          ><br />
        </p>
        <p v-for="(owner, idx) in coOwnerInfo" :key="idx">
          <span>
            <font-awesome-icon icon="paw" :color="'transparent'" />&nbsp;
            <span
              >{{ owner.firstName }} {{ owner.lastName }}
              <span v-if="!!owner.memberId">
                (Member: {{ owner.memberId }})</span
              ></span
            >
          </span>
          <br />
        </p>
      </div>
    </v-form>
    <v-overlay :value="processingRequest">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <hosted-registration-payment
      :disabled="!isValid || processingRequest || price === null"
      buttonText="Register"
      v-on:updatePaymentInfo="($event) => {
        processingRequest = true;
        sendRegistrationRequest($event);
      }"
    />
    <p class="steps">STEP <b>2</b> OF <b>2</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
import FooterText from "@/components/common/FooterText.vue";
import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import { getErrorMessage } from "@/services/errorHandler";

const thumbsUpImage = require('@/assets/thumbs-up-duotone.svg');

export default Vue.extend({
  components: { FooterText, HostedRegistrationPayment, SimpleFeeTable },
  name: "RegisterKennelForm2",
  data: function () {
    return {
      thumbsUpImage,
      dialog: false,
      dialogError: false,
      isValid: true,
      processingRequest: false,
      errorMessage: "",
    };
  },
  props: {
    changePage: Function,
    coOwnerInfo: Array,
    sendRegistrationRequest: Function,
    status: Object,
    price: Number,
    priceInfo: Object,
  },
  watch: {
    status: function (newVal: any, oldVal: any) {
      if (newVal?.success) {
        this.openModal();
      } else {
        this.errorMessage = getErrorMessage(newVal);
        this.openErrorModal();
      }
    },
    dialog: function (newVal: boolean, oldVal: boolean) {
      if (!newVal) {
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      }
    },
    dialogError: function (newVal: boolean, oldVal: boolean) {      
      if (!newVal && this.status?.data?.paymentIssue) {
        this.processingRequest = false;
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      } else if (!newVal) {
        this.processingRequest = false;
      }
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    openModal: function () {
      this.$data.dialog = true;
    },
    openErrorModal: function () {
      this.$data.dialogError = true;
    },
  },
});
</script>
